import { withInstall } from '@zoryn/utils'
import Rate from './src/rate.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZRate: SFCWithInstall<typeof Rate> = withInstall(Rate)
export default ZRate

export * from './src/rate'
